import { createContext } from 'react';

/**
 * True while the tab around a section is already showing its own "nothing recorded yet" callout.
 *
 * An empty tab offered the adviser Process documents and Ask Siesta twice — once from the tab and
 * again from the cashflow models section inside it — which reads as a bug rather than emphasis.
 * The tab is the one that knows, so it says so here and the inner callout stands down.
 */
export const TabShowsItsOwnEmptyState = createContext(false);
